// Imports => React
import { forwardRef, useImperativeHandle, useEffect, memo } from 'react';

// Imports => Config
import config from '@config';

let acm_timer = null;
let acm_timestamp = new Date().getTime();

const AcActivityMonitor = forwardRef(({ callback, authorized }, ref) => {
  useEffect(() => {
    if (config.autologout && config.autologout.active) {
      addEvents();
      checkActivity();
    }

    return () => {
      removeEvents();
    };
  }, []);

  const getDifference = (dt2, dt1, minutes = true) => {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    if (minutes) diff /= 60;
    return Math.abs(Math.round(diff));
  };

  useImperativeHandle(ref, () => ({
    restart: () => {
      if (!authorized) return;
      acm_timestamp = new Date().getTime();
      checkActivity();
    },
    stop: () => {
      if (acm_timer) clearTimeout(acm_timer);
    },
  }));

  const checkActivity = () => {
    if (acm_timer) clearTimeout(acm_timer);

    acm_timer = setTimeout(() => {
      const now = new Date();
      const end = new Date(acm_timestamp);

      const difference = getDifference(now, end);

      let timeoutConfig = (config.autologout.time || 15);
      // difference & autologout.time in minutes
      if (difference >= (timeoutConfig + 1)) {
        if (callback) {
          callback();
        }

        setTimeout(function () {
          const unauthenticatedEvent = new CustomEvent('unAuthenticate');
          window.dispatchEvent(unauthenticatedEvent);
        }, 100);
      } else if (difference >= timeoutConfig) {
        if (acm_timer) {
          clearTimeout(acm_timer);
        }
        if (callback) {
          callback();
        }
      } else {
        checkActivity();
      }
    }, 5 * 1000);
  };

  const updateActivity = () => {
    acm_timestamp = new Date().getTime();
  };

  const addEvents = () => {
    window.addEventListener('mousemove', updateActivity, { passive: true });
    window.addEventListener('keydown', updateActivity, { passive: true });
    window.addEventListener('keyup', updateActivity, { passive: true });
    window.addEventListener('unAuthenticate', stop);
  };

  const removeEvents = () => {
    window.removeEventListener('mousemove', updateActivity, { passive: true });
    window.removeEventListener('keydown', updateActivity, { passive: true });
    window.removeEventListener('keyup', updateActivity, { passive: true });
  };

  return null;
});

export default memo(AcActivityMonitor);
